import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaPeriodoExperiencia = () => {
  return (
    <MetricaBase
      titulo="Período de Experiência"
      descricao="Análise de colaboradores ativos em período de experiência vs efetivados"
      endpoint="periodo-experiencia"
      tipoDownload="periodo-experiencia"
      cor="cyan"
      mostrarGraficoArea={false}
    />
  );
};

export default MetricaPeriodoExperiencia;